import { render, staticRenderFns } from "./PlanificationDemo.vue?vue&type=template&id=71130734&scoped=true"
import script from "./PlanificationDemo.vue?vue&type=script&lang=js"
export * from "./PlanificationDemo.vue?vue&type=script&lang=js"
import style0 from "./PlanificationDemo.vue?vue&type=style&index=0&id=71130734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71130734",
  null
  
)

export default component.exports